import { motion } from "framer-motion";
import { DishGrid } from "@/components/z6/DishCard";
import { filterCourse } from "@/context/FiltersContext";
import { CROSS_CONTACT } from "@/lib/constants";

const COURSES = [["starter", "Small Plates"], ["main", "Large Plates"], ["dessert", "Desserts"]];

export const CrossContact = ({ testId = "cross-contact-note", className = "" }) => (
  <p data-testid={testId} className={`font-ui rounded-2xl bg-white/80 px-4 py-3 text-[15px] leading-relaxed text-[#0B2E44] ring-1 ring-[#0B5C8A]/15 ${className}`}>{CROSS_CONTACT}</p>
);

export const ChefCard = ({ course, testId }) => (
  <div data-testid={testId} className="dish-glass flex min-h-[140px] items-center gap-4 rounded-[26px] px-6 py-6">
    <div className="hara-orb hara-orb-sm shrink-0" aria-hidden><span className="hara-orb-core" /><span className="hara-orb-ring" /></div>
    <p className="font-ui text-[15px] leading-relaxed text-[#0B2E44]">Ask your server, our chef can adapt a {course} for you.</p>
  </div>
);

export const FilteredResults = ({ dishes, filters, onOpen, badgeFor }) => {
  const groups = COURSES.map(([key, label]) => ({ key, label, ...filterCourse(dishes, key, filters) }));
  return (
    <div className="space-y-12">
      <CrossContact />
      {groups.map((g) => (
        <motion.section key={g.key} layout data-testid={`results-course-${g.key}`} className="space-y-5">
          <div className="flex items-baseline gap-4">
            <h2 className="font-display text-4xl text-[#0B2E44] sm:text-5xl">{g.label}</h2>
            <span className="h-px flex-1" style={{ background: "linear-gradient(90deg, rgba(240,141,181,0.55), transparent)" }} />
          </div>
          {g.fallback && <p data-testid={`results-veg-fallback-${g.key}`} className="font-ui text-[15px] text-[#0B2E44]">No non-veg {g.key}s tonight, so here are our veg ones.</p>}
          {g.list.length ? <DishGrid dishes={g.list} onOpen={onOpen} badgeFor={badgeFor} testId={`results-grid-${g.key}`} />
            : <ChefCard course={g.key} testId={`chef-adapt-${g.key}`} />}
        </motion.section>
      ))}
    </div>
  );
};
